import { AuditLog } from "@common/types/auditLog";
import { AuditLogActor } from "../AuditLogActor";

interface Props {
    log: AuditLog;
}

export const TransactionLogCounterpartyContent: React.FC<Props> = ({ log }) => {
    const newValue =
        log.diff.find((d) => d.field === "counterpartyId")?.after?.valueLabel ??
        "";
    return (
        <>
            <AuditLogActor
                actorId={log.actorId}
                actorName={log.actorName}
                actorType={log.actorType}
                log={log}
            />{" "}
            updated counterparty to <strong>{newValue}</strong>.
        </>
    );
};
